import type { AnyAction, Middleware } from 'redux';
import { builderAnalyticsEvent, editorStartEvent, trackCampaignBuilderEvent } from './analytics';
import type { BuilderEvent, BuilderState } from './reducer';

type StateWithCampaignBuilder = { campaignBuilder?: BuilderState };

const isBuilderEvent = (action: AnyAction): action is BuilderEvent => (
  typeof action.type === 'string' && action.type.startsWith('campaignBuilder.')
);

export const campaignBuilderAnalyticsMiddleware: Middleware<object, StateWithCampaignBuilder> = store => next => (action: AnyAction) => {
  const prevState = isBuilderEvent(action) ? store.getState().campaignBuilder : undefined;
  const result = next(action);
  const nextState = store.getState().campaignBuilder;

  if (isBuilderEvent(action) && prevState && nextState) {
    trackCampaignBuilderEvent(builderAnalyticsEvent(prevState, action, nextState));
    trackCampaignBuilderEvent(editorStartEvent(prevState, nextState));
  }

  return result;
};
